import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getAverageCorrectAnswers, getAverageRepetitionsforUser, getUsersPerTime } from "../../redux/helpers";
import { CardRadialBar, CardLineChart, CardUsersPerProyect, CardRepeatPerUser } from "../common";
import { CustomMainContent, CardAnalyticsXl } from "../../components";
import CardAnalytics from "../../components/common/CardAnalytics";
import { LearningDashboardCemex } from "./ViewsUniques/LearningDashboardCemex";
import { LearningDashboardSimiAr } from "./ViewsUniques/LearningDashboardSimiAr";
import { LearningDashboardParesa } from "./ViewsUniques/LearningDashboardParesa";
import { LearningDashboardSimiVr } from "./ViewsUniques/LearningDashboardSimiVr";

const LearningDashboard = () => {
    const { proyectSelected, groups } = useSelector((state) => state.vrlSlice);
    const { arrayData } = useSelector(state => state.table)
    const [repetByUsers, setRepetByUsers] = useState(0)
    const [averageResponses, setAverageResponses] = useState(0)
    const [numberusersInTime, setNumberusersInTime] = useState([])

    useEffect(() => {
        const getUsers = async () => {
            setAverageResponses(getAverageCorrectAnswers(arrayData))
            setRepetByUsers(getAverageRepetitionsforUser(arrayData));
            setNumberusersInTime(getUsersPerTime(arrayData))
        }
        if (proyectSelected._id === "672e4328031ac03e79f58508") {

        }
        else {
            getUsers()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [arrayData, groups])

    const onFilterAverageResponses = (starDate, endDate) => {
        setAverageResponses(getAverageCorrectAnswers(arrayData, starDate, endDate))
    }
    const onfFilterRepeatByUsers = (starDate, endDate) => {
        setRepetByUsers(getAverageRepetitionsforUser(arrayData, starDate, endDate))
    }
    const onFilterNumberUsersInTime = (starDate, endDate, jumps) => {
        setNumberusersInTime(getUsersPerTime(arrayData, jumps, starDate, endDate))
    }



    if (proyectSelected._id === "672e4328031ac03e79f58508") {
        return (
            <LearningDashboardCemex></LearningDashboardCemex>
        )
    }
    if (proyectSelected._id === "66155e601e91fe7bde671941") {
        return (
            <LearningDashboardSimiAr></LearningDashboardSimiAr>
        )
    }
    if (proyectSelected._id === "679965563ed6fed031d3b488") {
        return (
            <LearningDashboardParesa></LearningDashboardParesa>
        )
    }
    if (proyectSelected._id === "6610c73702c6d8edebbe9154") {
        // SIMI vr
        return (
            <LearningDashboardSimiVr></LearningDashboardSimiVr>
        )
    }
    else if (arrayData.length > 0) {
        return (
            <CustomMainContent>
                <div className="flex w-full min-w-[450px] h-full ">
                    <div className="w-100-68 overflow-y-auto">
                        <div className="flex flex-wrap w-full  overflow-y-auto ">
                            <CardAnalytics title="Porcentaje completado por persona" callbackDate={onFilterAverageResponses} >
                                <CardRadialBar averageResponses={averageResponses ? averageResponses : 0}></CardRadialBar>
                            </CardAnalytics>
                            <CardAnalytics title="Repeticiones hechas por persona" callbackDate={onfFilterRepeatByUsers} bottomText="10% desde ultima semana" >
                                <CardRepeatPerUser repetByUsers={repetByUsers ? repetByUsers : 0} />
                            </CardAnalytics>
                            <CardAnalyticsXl title="Nuevos usuarios" callbackDate={onFilterNumberUsersInTime} >
                                <CardLineChart usersInTime={numberusersInTime}></CardLineChart>
                            </CardAnalyticsXl>
                            <CardAnalyticsXl title="Número total de personas registradas en cada capacitación" bottomText="10% desde ultima semana">
                                <CardUsersPerProyect></CardUsersPerProyect>
                            </CardAnalyticsXl>
                        </div>
                    </div>
                    <div className="w-[68px] h-full flex justify-center">
                        {/* <HelpButtons /> */}
                    </div>
                </div>
            </CustomMainContent>
        );
    }
    else {
        return (<></>)
    }

};

export default LearningDashboard;
